import { QueryClient } from "@tanstack/react-query";
import { get, post, postFormData } from "./fetch.core";
import { ProductFile, ProductFileFilter, ProductFileListResponse, ProductFileUploadResponse } from "../types/productFile";

export async function uploadProductFiles(files: FileList, queryClient: QueryClient) {
  const formData = new FormData();

  for (const file of files) {
    formData.append("file", file);
  }

  const res = await postFormData<ProductFileUploadResponse[]>("/admin/productFile/upload", formData);

  queryClient.invalidateQueries({ queryKey: ["productFiles"] });

  return res.data;
}

export async function list(filter: ProductFileFilter) {
  const { page = 0 } = filter;

  const queryParams = new URLSearchParams({
    "paging.page": page.toString(),
  });

  if (filter.type) {
    queryParams.append("type", filter.type);
  }

  if (filter.productId) {
    queryParams.append("productId", filter.productId);
  }

  const res = await get<ProductFileListResponse>(`/admin/productFile/list?${queryParams.toString()}`);
  return res.data;
}

export async function single(id: string) {
  const res = await get<ProductFile>(`/admin/productFile/get?id=${id}`);
  return res.data;
}

export async function deleteProductFile(id: string) {
  const res = await post("/admin/productFile/delete", { id });
  return res.data;
}

export async function update(
  id: string,
  data: {
    type?: string;
    language?: string;
    name?: string;
    productIds?: string[];
  }
) {
  const res = await post("/admin/productFile/update", {
    id,
    type: data.type,
    name: data.name,
    language: data.language,
    productIds: data.productIds,
  });
  return res.data;
}
